<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-text class="pt-4" style="font-size: 1.3rem">
          {{ $t("download.body") }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="$emit('close')"
            style="font-size: 1.1rem; letter-spacing: 0px"
          >
            {{ $t("download.okay") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["dialog"],
};
</script>
